import InfoLayout from "../components/InfoLayout";
import usePageMeta from "../hooks/usePageMeta";
import {
  CHEAPEST_HPI_PATH,
  cheapestHpiCopy,
  competitorPrices,
} from "../content/cheapestHpiCheck";

// ServiceLad's landing page for "cheapest HPI check" searches. The prerendered
// copy (scripts/prerender-pages.mjs) renders the same content module.
export default function CheapestHpiCheckPage({ brand }) {
  const copy = cheapestHpiCopy();
  const { risk } = copy;
  usePageMeta({
    title: copy.metaTitle,
    description: copy.metaDescription,
    canonical: `https://${brand.domain}${CHEAPEST_HPI_PATH}`,
  });

  return (
    <InfoLayout brand={brand} eyebrow="Full HPI check" title={copy.h1} intro={copy.lead}>
      <section className="content">
        <div className="wrap prose">
          <section className="search-card hpi-search">
            <h2>{copy.formHeading}</h2>
            <p>{copy.formCopy}</p>
            {/* A plain GET form, like the prerendered one: checkout reads vrm and plan. */}
            <form className="search" action="/checkout" method="get">
              <input type="hidden" name="plan" value="risk" />
              <input name="vrm" maxLength="8" autoComplete="off" aria-label="UK registration" placeholder="ENTER REG" required />
              <button type="submit">{copy.formButton}</button>
            </form>
            <p className="search-price">{risk.name} £{risk.plate} · one-off payment, no subscription. <a href="/pricing">See what each check includes</a>.</p>
          </section>

          <h2>{copy.compareHeading}</h2>
          <div className="guide-table-wrap">
            <table className="guide-table">
              <caption>{copy.compareNote}</caption>
              <thead><tr><th scope="col">Provider</th><th scope="col">Check</th><th scope="col">Price</th></tr></thead>
              <tbody>
                <tr><th scope="row">ServiceLad</th><td>{risk.name}</td><td><strong>£{risk.plate}</strong></td></tr>
                {competitorPrices.map((row) => (
                  <tr key={row.provider}><th scope="row">{row.provider}</th><td>{row.product}</td><td>£{row.price}</td></tr>
                ))}
              </tbody>
            </table>
          </div>

          <h2>{copy.includedHeading}</h2>
          <ul>{risk.items.map((item) => <li key={item}>{item}</li>)}</ul>
          <p>{copy.includedNote}</p>

          <h2>{copy.whyHeading}</h2>
          {copy.whyBody.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}

          <h2>{copy.differHeading}</h2>
          {copy.differBody.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}

          <h2>{copy.serviceHeading}</h2>
          <p>{copy.serviceBody}</p>
          <p><a href="/checkout?plan=complete">Get the full check with service history</a></p>

          <div className="guide-faq">
            <h2>{copy.faqHeading}</h2>
            {copy.faqs.map((faq) => (
              <div key={faq.q}><h3>{faq.q}</h3><p>{faq.a}</p></div>
            ))}
          </div>
        </div>
      </section>
    </InfoLayout>
  );
}
